module.exports = __webpack_public_path__ + "static/media/fmc-app-phone.412847f6.svg";